import React, { useState } from "react";

import LivePositionsTable from "./LivePositionsTable";
import OpenOrdersTable from "./OpenOrdersTable";
import LoadingSpinner from "../../components/loading-spinner";
import { CalendarClockIcon, ChevronDownIcon, FilterIcon } from "lucide-react";
import { useEffect } from "react";
import { useRef } from "react";
import LiveTradeHistoryDataTable from "./LiveTradeHistory";
import ClosePositionsTable from "./ClosePositionTable";
import RejectedOrdersTable from "./RejectedOrdersTable";
import OrderPlacement from "./OrderPlacement";
import OrderTaggingSystem from "./OrderTagging";
import NewOpenOrdersTable from "./NewOpenOrderTable";
import NewLivePositionsRestAccounts from "./NewLivePositionsRestAccounts";
import NewLiveTradesTable from "./NewLiveTradesTable";
import NewRejectedOrdersTable from "./NewRejectedOrdersTable";
import NewClosePositionsTable from "./NewClosePositionsTable";

export default function ShowForexOrdersData({ userId, allUser, ...props }) {
  const [currentTab, setCurrentTab] = useState("order-placement");

  const [filterDropDown, setFilterDropDown] = useState(false);
  const [filterByDays, setFilterByDays] = useState(false);
  const [selectedRadio, setSelectedRadio] = useState(null);

  const [userOpenOrdersFno, setUserOpenOrdersFno] = useState([]);
  const [userOpenOrdersEquity, setUserOpenOrdersEquity] = useState([]);
  const [userLivePositionsFno, setUserLivePositionsFno] = useState([]);
  const [userLivePositionsEquity, setUserLivePositionsEquity] = useState([]);
  const [userClosePositionsFno, setUserClosePositionsFno] = useState([]);
  const [userClosePositionsEquity, setUserClosePositionsEquity] = useState([]);
  const [userLiveTradesFno, setUserLiveTradesFno] = useState([]);
  const [userLiveTradesEquity, setUserLiveTradesEquity] = useState([]);
  const [userRejectedOrdersFno, setUserRejectedOrdersFno] = useState([]);
  const [userRejectedOrdersEquity, setUserRejectedOrdersEquity] = useState([]);

  const [filteredOpenOrdersFno, setFilteredOpenOrdersFno] =
    useState(userOpenOrdersFno);
  const [filteredOpenOrdersEquity, setFilteredOpenOrdersEquity] =
    useState(userOpenOrdersEquity);
  const [filteredLivePositionsFno, setFilteredLivePositionsFno] =
    useState(userLivePositionsFno);
  const [filteredLivePositionsEquity, setFilteredLivePositionsEquity] =
    useState(userLivePositionsEquity);

  const [filteredClosePositionsFno, setFilteredClosePositionsFno] = useState(
    userClosePositionsFno
  );
  const [filteredClosePositionsEquity, setFilteredClosePositionsEquity] =
    useState(userClosePositionsEquity);

  const [filteredLiveTradesFno, setFilteredLiveTradesFno] =
    useState(userLiveTradesFno);
  const [filteredLiveTradesEquity, setFilteredLiveTradesEquity] =
    useState(userLiveTradesEquity);
  const [filteredRejectedOrdersFno, setFilterRejectedOrdersFno] = useState(
    userRejectedOrdersFno
  );
  const [filteredRejectedOrdersEquity, setFilterRejectedOrdersEquity] =
    useState(userRejectedOrdersEquity);
  const [sortOrder, setSortOrder] = useState("asc");

  const filterByDaysRef = useRef(null);
  const filterDropDownRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        filterByDaysRef.current &&
        !filterByDaysRef.current.contains(event.target) &&
        filterByDays
      ) {
        closeFilterByDaysModal();
      }

      if (
        filterDropDownRef.current &&
        !filterDropDownRef.current.contains(event.target) &&
        filterDropDown
      ) {
        closeFilterDroprDownModal();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [filterByDays, filterDropDown]);

  const showFilterDroprDownModal = () => {
    setFilterDropDown(true);
  };

  const showFilterByDaysModal = () => {
    setFilterByDays(true);
  };

  const closeFilterDroprDownModal = () => {
    setFilterDropDown(false);
  };

  const closeFilterByDaysModal = () => {
    setFilterByDays(false);
  };

  const handleRadioChange = (name) => {
    setSelectedRadio(name);
    console.log(`Selected Radio: ${name}`);
  };

  const handleChangeTabs = (tabName) => {
    setCurrentTab(tabName);
  };

  const [show, setShow] = useState(false);

  const [state, setState] = useState("FNO");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const loadInitialOrdersData = () => {
      const fnoPositions =
        props.positionsOrders &&
        props.positionsOrders.filter((symbol) => {
          const sym = symbol?.symbol || "";
          const lastTwoCharacters = symbol?.symbol?.slice(-2);
          const regex = /\b(CE|PE|UT)\b/;
          return (
            lastTwoCharacters === "PE" ||
            lastTwoCharacters === "CE" ||
            lastTwoCharacters === "UT" ||
            regex.test(sym)
          );
        });

      const filteredPositionsFNO = fnoPositions.reduce(
        (uniqueClientIdArray, currentItem) => {
          const { symbol, side, netQty, netAvg, ltp, strategy, pl, client_id } =
            currentItem;

          // Check if an object with the same properties already exists in the uniqueClientIdArray
          const existingItemIndex = uniqueClientIdArray.findIndex(
            (item) =>
              item.symbol === symbol &&
              item.netQty === netQty &&
              item.strategy === strategy
          );

          // If no matching object is found, add a new object with clientId to the uniqueClientIdArray
          if (existingItemIndex === -1) {
            uniqueClientIdArray.push({
              symbol,
              side,
              netQty,
              netAvg,
              ltp,
              strategy,
              pl,
              clientIds: [client_id],
            });
          } else {
            // If a matching object is found, add the clientId to the matching item's clientIds array
            uniqueClientIdArray[existingItemIndex].clientIds.push(client_id);
          }

          return uniqueClientIdArray;
        },
        []
      );

      filteredPositionsFNO.sort((a, b) => {
        const dateA = new Date(a.orderDateTime);
        const dateB = new Date(b.orderDateTime);
        return dateB - dateA;
      });

      const openPositionsFno = filteredPositionsFNO.filter(
        (item) => item.netQty !== 0
      );
      const closePositionsFno = filteredPositionsFNO.filter(
        (item) => item.netQty === 0
      );

      setUserLivePositionsFno(openPositionsFno);
      setFilteredLivePositionsFno(openPositionsFno);
      setUserClosePositionsFno(closePositionsFno);
      setFilteredClosePositionsFno(closePositionsFno);

      const equityPositions =
        props.positionsOrders &&
        props.positionsOrders.filter((symbol) => {
          const lastTwoCharacters = symbol?.symbol?.slice(-2);
          return (
            lastTwoCharacters !== "PE" &&
            lastTwoCharacters !== "CE" &&
            lastTwoCharacters !== "UT"
          );
        });

      const filteredPositionsEquity = equityPositions.reduce(
        (uniqueClientIdArray, currentItem) => {
          const { symbol, side, netQty, netAvg, ltp, strategy, pl, client_id } =
            currentItem;

          // Check if an object with the same properties already exists in the uniqueClientIdArray
          const existingItemIndex = uniqueClientIdArray.findIndex(
            (item) =>
              item.symbol === symbol &&
              item.netQty === netQty &&
              item.strategy === strategy
          );

          // If no matching object is found, add a new object with clientId to the uniqueClientIdArray
          if (existingItemIndex === -1) {
            uniqueClientIdArray.push({
              symbol,
              side,
              netQty,
              netAvg,
              ltp,
              strategy,
              pl,
              clientIds: [client_id],
            });
          } else {
            // If a matching object is found, add the clientId to the matching item's clientIds array
            uniqueClientIdArray[existingItemIndex].clientIds.push(client_id);
          }

          return uniqueClientIdArray;
        },
        []
      );

      filteredPositionsEquity.sort((a, b) => {
        const dateA = new Date(a.orderDateTime);
        const dateB = new Date(b.orderDateTime);
        return dateB - dateA;
      });

      const openPositionsEquity = filteredPositionsEquity.filter(
        (item) => item.netQty !== 0
      );
      const closePositionsEquity = filteredPositionsEquity.filter(
        (item) => item.netQty === 0
      );

      setUserLivePositionsEquity(openPositionsEquity);
      setFilteredLivePositionsEquity(openPositionsEquity);
      setUserClosePositionsEquity(closePositionsEquity);
      setFilteredClosePositionsEquity(closePositionsEquity);

      // const filteredLiveOrder =
      //   props.liveOrders &&
      //   props.liveOrders.filter((symbol) => {
      //     const lastTwoCharacters = symbol?.symbol?.slice(-2);
      //     return lastTwoCharacters === "PE" || lastTwoCharacters === "CE" || lastTwoCharacters === "UT";
      //   });

      const filteredLiveOrder =
        props.liveOrders &&
        props.liveOrders.filter((symbol) => {
          const sym = symbol?.symbol || "";
          const lastTwoCharacters = sym.slice(-2);
          const regex = /\b(CE|PE|UT)\b/;
          return (
            lastTwoCharacters === "PE" ||
            lastTwoCharacters === "CE" ||
            lastTwoCharacters === "UT" ||
            regex.test(sym)
          );
        });

      console.log("Filtere live orders are", filteredLiveOrder);

      const filteredLiveOrderFNO = filteredLiveOrder.reduce(
        (uniqueClientIdArray, currentItem) => {
          const {
            symbol,
            side,
            qty,
            remainingQuantity,
            limitPrice,
            stopPrice,
            status,
            strategy,
            omsMessage,
            orderDateTime,
            clientId,
          } = currentItem;

          // Check if an object with the same properties already exists in the uniqueClientIdArray
          const existingItemIndex = uniqueClientIdArray.findIndex(
            (item) =>
              item.symbol === symbol &&
              item.side === side &&
              item.qty === qty &&
              item.remainingQuantity === remainingQuantity &&
              item.limitPrice === limitPrice &&
              item.stopPrice === stopPrice &&
              item.status === status &&
              item.strategy === strategy
          );

          // If no matching object is found, add a new object with clientId to the uniqueClientIdArray
          if (existingItemIndex === -1) {
            uniqueClientIdArray.push({
              symbol,
              side,
              qty,
              remainingQuantity,
              limitPrice,
              stopPrice,
              status,
              strategy,
              omsMessage,
              orderDateTime,
              clientIds: [clientId],
            });
          } else {
            // If a matching object is found, add the clientId to the matching item's clientIds array
            uniqueClientIdArray[existingItemIndex].clientIds.push(clientId);
          }

          return uniqueClientIdArray;
        },
        []
      );

      filteredLiveOrderFNO.sort((a, b) => {
        const dateA = new Date(a.orderDateTime);
        const dateB = new Date(b.orderDateTime);
        return dateB - dateA;
      });

      // console.log("filtered Open Orders",filteredLiveOrderFNO)
      setUserOpenOrdersFno(filteredLiveOrderFNO);
      setFilteredOpenOrdersFno(filteredLiveOrderFNO);

      // const filteredRejectedOrder =
      //   props.rejectedOrders &&
      //   props.rejectedOrders.filter((symbol) => {
      //     const lastTwoCharacters = symbol?.symbol?.slice(-2);
      //     return lastTwoCharacters === "PE" || lastTwoCharacters === "CE" || lastTwoCharacters === "UT";
      //   });

      const filteredRejectedOrder =
        props?.rejectedOrders &&
        props?.rejectedOrders?.filter((symbol) => {
          const sym = symbol?.symbol || "";
          const lastTwoCharacters = sym.slice(-2);
          const regex = /\b(CE|PE|UT)\b/;
          return (
            lastTwoCharacters === "PE" ||
            lastTwoCharacters === "CE" ||
            lastTwoCharacters === "UT" ||
            regex.test(sym)
          );
        });

      console.log("Filtere rejected orders are", filteredRejectedOrder);

      const filteredRejectedOrderFNO = filteredRejectedOrder.reduce(
        (uniqueClientIdArray, currentItem) => {
          const {
            symbol,
            side,
            qty,
            remainingQuantity,
            limitPrice,
            stopPrice,
            status,
            strategy,
            message,
            orderDateTime,
            clientId,
          } = currentItem;

          // Check if an object with the same properties already exists in the uniqueClientIdArray
          const existingItemIndex = uniqueClientIdArray.findIndex(
            (item) =>
              item.symbol === symbol &&
              item.side === side &&
              item.qty === qty &&
              item.remainingQuantity === remainingQuantity &&
              item.limitPrice === limitPrice &&
              item.stopPrice === stopPrice &&
              item.status === status &&
              item.strategy === strategy
          );

          // If no matching object is found, add a new object with clientId to the uniqueClientIdArray
          if (existingItemIndex === -1) {
            uniqueClientIdArray.push({
              symbol,
              side,
              qty,
              remainingQuantity,
              limitPrice,
              stopPrice,
              status,
              strategy,
              message,
              orderDateTime,
              clientIds: [clientId],
            });
          } else {
            // If a matching object is found, add the clientId to the matching item's clientIds array
            uniqueClientIdArray[existingItemIndex].clientIds.push(clientId);
          }

          return uniqueClientIdArray;
        },
        []
      );

      filteredRejectedOrderFNO.sort((a, b) => {
        const dateA = new Date(a.orderDateTime);
        const dateB = new Date(b.orderDateTime);
        return dateB - dateA;
      });

      // const rejectedOrders = filteredRejectedOrderFNO.filter(item => item.status === "5" || item.status === "Pending")
      setUserRejectedOrdersFno(filteredRejectedOrderFNO);
      setFilterRejectedOrdersFno(filteredRejectedOrderFNO);

      const filteredEquityLiveOrder =
        props.liveOrders &&
        props.liveOrders.filter((symbol) => {
          const lastTwoCharacters = symbol?.symbol?.slice(-2);
          return (
            lastTwoCharacters !== "PE" &&
            lastTwoCharacters !== "CE" &&
            lastTwoCharacters !== "UT"
          );
        });

      const filteredLiveOrdersEquity = filteredEquityLiveOrder.reduce(
        (uniqueClientIdArray, currentItem) => {
          const {
            symbol,
            side,
            qty,
            remainingQuantity,
            limitPrice,
            stopPrice,
            status,
            strategy,
            omsMessage,
            orderDateTime,
            clientId,
          } = currentItem;

          // Check if an object with the same properties already exists in the uniqueClientIdArray
          const existingItemIndex = uniqueClientIdArray.findIndex(
            (item) =>
              item.symbol === symbol &&
              item.side === side &&
              item.qty === qty &&
              item.remainingQuantity === remainingQuantity &&
              item.limitPrice === limitPrice &&
              item.stopPrice === stopPrice &&
              item.status === status &&
              item.strategy === strategy
          );

          // If no matching object is found, add a new object with clientId to the uniqueClientIdArray
          if (existingItemIndex === -1) {
            uniqueClientIdArray.push({
              symbol,
              side,
              qty,
              remainingQuantity,
              limitPrice,
              stopPrice,
              status,
              strategy,
              omsMessage,
              orderDateTime,
              clientIds: [clientId],
            });
          } else {
            // If a matching object is found, add the clientId to the matching item's clientIds array
            uniqueClientIdArray[existingItemIndex].clientIds.push(clientId);
          }

          return uniqueClientIdArray;
        },
        []
      );

      filteredLiveOrdersEquity.sort((a, b) => {
        const dateA = new Date(a.orderDateTime);
        const dateB = new Date(b.orderDateTime);
        return dateB - dateA;
      });

      console.log("filtered Open Orders", filteredLiveOrdersEquity);

      setUserOpenOrdersEquity(filteredLiveOrdersEquity);
      setFilteredOpenOrdersEquity(filteredLiveOrdersEquity);

      const filteredEquityRejectedOrder =
        props.rejectedOrders &&
        props.rejectedOrders.filter((symbol) => {
          const lastTwoCharacters = symbol?.symbol?.slice(-2);
          return (
            lastTwoCharacters !== "PE" &&
            lastTwoCharacters !== "CE" &&
            lastTwoCharacters !== "UT"
          );
        });

      const filteredRejectedOrdersEquity = filteredEquityRejectedOrder.reduce(
        (uniqueClientIdArray, currentItem) => {
          const {
            symbol,
            side,
            qty,
            remainingQuantity,
            limitPrice,
            stopPrice,
            status,
            strategy,
            omsMessage,
            orderDateTime,
            clientId,
          } = currentItem;

          // Check if an object with the same properties already exists in the uniqueClientIdArray
          const existingItemIndex = uniqueClientIdArray.findIndex(
            (item) =>
              item.symbol === symbol &&
              item.side === side &&
              item.qty === qty &&
              item.remainingQuantity === remainingQuantity &&
              item.limitPrice === limitPrice &&
              item.stopPrice === stopPrice &&
              item.status === status &&
              item.strategy === strategy
          );

          // If no matching object is found, add a new object with clientId to the uniqueClientIdArray
          if (existingItemIndex === -1) {
            uniqueClientIdArray.push({
              symbol,
              side,
              qty,
              remainingQuantity,
              limitPrice,
              stopPrice,
              status,
              strategy,
              omsMessage,
              orderDateTime,
              clientIds: [clientId],
            });
          } else {
            // If a matching object is found, add the clientId to the matching item's clientIds array
            uniqueClientIdArray[existingItemIndex].clientIds.push(clientId);
          }

          return uniqueClientIdArray;
        },
        []
      );

      filteredRejectedOrdersEquity.sort((a, b) => {
        const dateA = new Date(a.orderDateTime);
        const dateB = new Date(b.orderDateTime);
        return dateB - dateA;
      });

      const rejectedOrdersEquity = filteredRejectedOrdersEquity.filter(
        (item) => item.status === 5
      );
      setUserRejectedOrdersEquity(rejectedOrdersEquity);
      setFilterRejectedOrdersEquity(rejectedOrdersEquity);

      // const fnoLiveTrades =
      //   props.liveTrade &&
      //   props.liveTrade.filter((symbol) => {
      //     const lastTwoCharacters = symbol?.symbol?.slice(-2);
      //     return lastTwoCharacters === "PE" || lastTwoCharacters === "CE" || lastTwoCharacters === "UT";
      //   });

      const fnoLiveTrades =
        props.liveTrade &&
        props.liveTrade.filter((symbol) => {
          const sym = symbol?.symbol || "";
          const lastTwoCharacters = sym.slice(-2);
          const regex = /\b(CE|PE|UT)\b/;
          return (
            lastTwoCharacters === "PE" ||
            lastTwoCharacters === "CE" ||
            lastTwoCharacters === "UT" ||
            regex.test(sym)
          );
        });

      const filteredLiveTradesFNO = fnoLiveTrades.reduce(
        (uniqueClientIdArray, currentItem) => {
          const {
            symbol,
            side,
            tradedqty,
            tradeprice,
            strategy,
            orderdatetime,
            clientid,
          } = currentItem;

          // Check if an object with the same properties already exists in the uniqueClientIdArray
          const existingItemIndex = uniqueClientIdArray.findIndex(
            (item) =>
              item.symbol === symbol &&
              item.side === side &&
              item.tradedqty === tradedqty &&
              item.tradeprice === tradeprice
          );

          // If no matching object is found, add a new object with clientId to the uniqueClientIdArray
          if (existingItemIndex === -1) {
            uniqueClientIdArray.push({
              symbol,
              side,
              tradedqty,
              tradeprice,
              strategy,
              orderdatetime,
              clientIds: [clientid],
            });
          } else {
            // If a matching object is found, add the clientId to the matching item's clientIds array
            uniqueClientIdArray[existingItemIndex].clientIds.push(clientid);
          }

          return uniqueClientIdArray;
        },
        []
      );

      filteredLiveTradesFNO.sort((a, b) => {
        const dateA = new Date(a.candle_timestamp);
        const dateB = new Date(b.candle_timestamp);
        return dateB - dateA;
      });

      setUserLiveTradesFno(filteredLiveTradesFNO);
      setFilteredLiveTradesFno(filteredLiveTradesFNO);

      const equityLiveTrades =
        props.liveTrade &&
        props.liveTrade.filter((symbol) => {
          const lastTwoCharacters = symbol?.symbol?.slice(-2);
          return (
            lastTwoCharacters !== "PE" &&
            lastTwoCharacters !== "CE" &&
            lastTwoCharacters !== "UT"
          );
        });

      const filteredEquityLiveTrades = equityLiveTrades.reduce(
        (uniqueClientIdArray, currentItem) => {
          const {
            symbol,
            side,
            tradedqty,
            tradeprice,
            strategy,
            orderdatetime,
            clientid,
          } = currentItem;

          // Check if an object with the same properties already exists in the uniqueClientIdArray
          const existingItemIndex = uniqueClientIdArray.findIndex(
            (item) =>
              item.symbol === symbol &&
              item.side === side &&
              item.tradedqty === tradedqty &&
              item.tradeprice === tradeprice
          );

          // If no matching object is found, add a new object with clientId to the uniqueClientIdArray
          if (existingItemIndex === -1) {
            uniqueClientIdArray.push({
              symbol,
              side,
              tradedqty,
              tradeprice,
              strategy,
              orderdatetime,
              clientIds: [clientid],
            });
          } else {
            // If a matching object is found, add the clientId to the matching item's clientIds array
            uniqueClientIdArray[existingItemIndex].clientIds.push(clientid);
          }

          return uniqueClientIdArray;
        },
        []
      );
      filteredEquityLiveTrades.sort((a, b) => {
        const dateA = new Date(a.candle_timestamp);
        const dateB = new Date(b.candle_timestamp);
        return dateB - dateA;
      });

      setUserLiveTradesEquity(filteredEquityLiveTrades);
      setFilteredLiveTradesEquity(filteredEquityLiveTrades);
    };

    loadInitialOrdersData();
  }, [props.liveOrders, props.positionsOrders, props.liveTrade]);

  // console.log("Live Trades ",props.liveTrade)

  return (
    <div className="z-0 relative w-full h-full items-end  overflow-hidden bg-black">
      <div className=" flex justify-between bg-[#0F0F0F] h-[60px] px-6 w-full">
        <div className="flex space-x-6">
          {/* <div
            onClick={() => handleChangeTabs("open-orders")}
            className={` ${
              currentTab === "open-orders"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px]  text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in    `}
          >
            Open Orders
          </div>
          <div
            onClick={() => handleChangeTabs("positions")}
            className={` ${
              currentTab === "positions"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in  `}
          >
            Open Positions
          </div>
          <div
            onClick={() => handleChangeTabs("close-positions")}
            className={` ${
              currentTab === "close-positions"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in  `}
          >
            Close Positions
          </div>
          <div
            onClick={() => handleChangeTabs("live-trades")}
            className={` ${
              currentTab === "live-trades"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in  `}
          >
            Live Trades
          </div>

          <div
            onClick={() => handleChangeTabs("rejected-orders")}
            className={` ${
              currentTab === "rejected-orders"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in  `}
          >
            Rejected Orders
          </div> */}
          <div
            onClick={() => handleChangeTabs("order-placement")}
            className={` ${
              currentTab === "order-placement"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in  `}
          >
            Order Placement
          </div>
          <div
            onClick={() => handleChangeTabs("order-tagging")}
            className={` ${
              currentTab === "order-tagging"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in  `}
          >
            Order Tagging
          </div>
        </div>

        <div className="relative flex space-x-4 items-center ">
          {currentTab === "live-trades" ? (
            <button
              onClick={props.updateLiveTradeData}
              className="flex items-center space-x-2 bg-gray-800/40 px-6 py-2.5 rounded-md"
            >
              <span className="text-white text-base">
                {props.liveTradeUpdating === true
                  ? "Updating .........."
                  : "Update Live Trades"}
              </span>
            </button>
          ) : currentTab === "positions" ? (
            <button
              onClick={props.updateLivePositionsData}
              className="flex items-center space-x-2 bg-gray-800/40 px-6 py-2.5 rounded-md"
            >
              <span className="text-white text-base">
                {props.livePositionUpdating === true
                  ? "Updating .........."
                  : "Update Positions Data"}
              </span>
            </button>
          ) : currentTab === "close-positions" ? (
            <button
              onClick={props.updateLivePositionsData}
              className="flex items-center space-x-2 bg-gray-800/40 px-6 py-2.5 rounded-md"
            >
              <span className="text-white text-base">
                {props.livePositionUpdating === true
                  ? "Updating .........."
                  : "Update Positions Data"}
              </span>
            </button>
          ) : currentTab === "open-orders" ? (
            <button
              onClick={props.updateData}
              className="flex items-center space-x-2 bg-gray-800/40 px-6 py-2.5 rounded-md"
            >
              <span className="text-white text-base">
                {props.updating === true
                  ? "Updating .........."
                  : "Update Open Orders"}
              </span>
            </button>
          ) : (
            ""
          )}

          <button
            onClick={() => setShow(true)}
            className="flex items-center space-x-2 bg-gray-800/40 px-6 py-2.5 rounded-md"
          >
            <span className="text-white text-base">{state}</span>
            <ChevronDownIcon className="h-5 w-5 text-white" />
          </button>

          {show === true && currentTab !== "order-placement" && currentTab !== "order-tagging" && (
            <div className="z-10 absolute top-16 right-[120px] bg-gray-800 w-[160px]  p-1 rounded-sm">
              <div className="flex  flex-col space-y-1 h-full p-2">
                <div
                  className="text-white text-base cursor-pointer hover:bg-gray-900 px-2 py-1 rounded-md "
                  onClick={() => {
                    setState("FNO");
                    setShow(false);
                    setCurrentPage(1);
                  }}
                >
                  FNO
                </div>
                <div
                  className="text-white text-base cursor-pointer hover:bg-gray-900 px-2 py-1 rounded-md "
                  onClick={() => {
                    setState("EQUITY");
                    setShow(false);
                  }}
                >
                  EQUITY
                </div>
              </div>
            </div>
          )}

          {currentTab !== "order-placement" && currentTab !== "order-tagging" && (
            <button
            ref={filterDropDownRef}
            onClick={showFilterDroprDownModal}
            className="flex items-center space-x-2 bg-gray-800/40 px-6 py-2.5 rounded-md"
          >
            <FilterIcon className="h-5 w-5 text-white" />
            <span className="text-white text-base">Filter</span>
          </button>
          )}

          

          {filterDropDown && (
            <div
              ref={filterDropDownRef}
              className="absolute top-16 right-0 bg-gray-800 w-[160px]  p-1 rounded-sm"
            >
              <div className="flex  flex-col space-y-4 n h-full p-2">
                <div className="text-white text-base cursor-pointer">
                  By Time
                </div>
                <div className="text-white text-base cursor-pointer">
                  Buy Orders
                </div>
                <div className="text-white text-base cursor-pointer">
                  Sell Orders
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* {livePositionsData ? (
        <pre>{JSON.stringify(livePositionData, null, 2)}</pre>
      ) : (
        <p>Waiting for data...</p>
      )}
      {openOrdersData ? (
        <pre>{JSON.stringify(openOrdersData, null, 2)}</pre>
      ) : (
        <p>Waiting for data...</p>
      )} */}

      {currentTab === "positions" && (
        <LivePositionsTable
          livePositionsData={
            state === "EQUITY" ? userLivePositionsEquity : userLivePositionsFno
          }
          filteredLivePositionsData={
            state === "EQUITY"
              ? filteredLivePositionsEquity
              : filteredLivePositionsFno
          }
          setFilteredLivePositionsFno={setFilteredLivePositionsFno}
          setFilteredLivePositionsEquity={setFilteredLivePositionsEquity}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          currentState={state}
          accountName={props.accountName}
          allUser={allUser && allUser}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          state={state}
        />
      )}


      {/* {currentTab === "close-positions" && (
        <ClosePositionsTable
          closePositionsData={
            state === "EQUITY"
              ? userClosePositionsEquity
              : userClosePositionsFno
          }
          filteredClosePositionsData={
            state === "EQUITY"
              ? filteredClosePositionsEquity
              : filteredClosePositionsFno
          }
          setFilteredClosePositionsFno={setFilteredClosePositionsFno}
          setFilteredClosePositionsEquity={setFilteredClosePositionsEquity}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          currentState={state}
          accountName={props.accountName}
          allUser={allUser && allUser}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )} */}

      {/* {currentTab === "open-orders" && (
        <OpenOrdersTable
          openOrdersData={
            state === "EQUITY" ? userOpenOrdersEquity : userOpenOrdersFno
          }
          filteredOpenOrdersData={
            state === "EQUITY"
              ? filteredOpenOrdersEquity
              : filteredOpenOrdersFno
          }
          setFilteredOpenOrdersFno={setFilteredOpenOrdersFno}
          setFilteredOpenOrdersEquity={setFilteredOpenOrdersEquity}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          currentState={state}
          accountName={props.accountName}
          allUser={allUser && allUser}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )} */}

      {/* {currentTab === "live-trades" && (
        <LiveTradeHistoryDataTable
          liveTradeData={
            state === "EQUITY" ? userLiveTradesEquity : userLiveTradesFno
          }
          filteredLiveTradesData={
            state === "EQUITY"
              ? filteredLiveTradesEquity
              : filteredLiveTradesFno
          }
          setFilteredLiveTradesFno={setFilteredLiveTradesFno}
          setFilteredLiveTradesEquity={setFilteredLiveTradesEquity}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          currentState={state}
          accountName={props.accountName}
          allUser={allUser && allUser}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )} */}

      {/* {currentTab === "rejected-orders" && (
        <RejectedOrdersTable
          rejectedOrdersData={
            state === "EQUITY"
              ? userRejectedOrdersEquity
              : userRejectedOrdersFno
          }
          filteredRejectedOrdersData={
            state === "EQUITY"
              ? filteredRejectedOrdersEquity
              : filteredRejectedOrdersFno
          }
          setFilterRejectedOrdersFno={setFilterRejectedOrdersFno}
          setFilterRejectedOrdersEquity={setFilterRejectedOrdersEquity}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          currentState={state}
          accountName={props.accountName}
          allUser={allUser && allUser}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )} */}


       {currentTab === "live-trades" && (
        <NewLiveTradesTable
          liveTradeData={
            state === "EQUITY" ? userLiveTradesEquity : userLiveTradesFno
          }
          filteredLiveTradesData={
            state === "EQUITY"
              ? filteredLiveTradesEquity
              : filteredLiveTradesFno
          }
          setFilteredLiveTradesFno={setFilteredLiveTradesFno}
          setFilteredLiveTradesEquity={setFilteredLiveTradesEquity}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          currentState={state}
          accountName={props.accountName}
          allUser={allUser && allUser}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}

      {currentTab === "close-positions" && (
        <NewClosePositionsTable
          closePositionsData={
            state === "EQUITY"
              ? userClosePositionsEquity
              : userClosePositionsFno
          }
          filteredClosePositionsData={
            state === "EQUITY"
              ? filteredClosePositionsEquity
              : filteredClosePositionsFno
          }
          setFilteredClosePositionsFno={setFilteredClosePositionsFno}
          setFilteredClosePositionsEquity={setFilteredClosePositionsEquity}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          currentState={state}
          accountName={props.accountName}
          allUser={allUser && allUser}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}


    

        {currentTab === "open-orders" && (
        <NewOpenOrdersTable
          openOrdersData={
            state === "EQUITY" ? userOpenOrdersEquity : userOpenOrdersFno
          }
          filteredOpenOrdersData={
            state === "EQUITY"
              ? filteredOpenOrdersEquity
              : filteredOpenOrdersFno
          }
          setFilteredOpenOrdersFno={setFilteredOpenOrdersFno}
          setFilteredOpenOrdersEquity={setFilteredOpenOrdersEquity}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          currentState={state}
          accountName={props.accountName}
          allUser={allUser && allUser}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}


   {currentTab === "rejected-orders" && (
        <NewRejectedOrdersTable
          rejectedOrdersData={
            state === "EQUITY"
              ? userRejectedOrdersEquity
              : userRejectedOrdersFno
          }
          filteredRejectedOrdersData={
            state === "EQUITY"
              ? filteredRejectedOrdersEquity
              : filteredRejectedOrdersFno
          }
          setFilterRejectedOrdersFno={setFilterRejectedOrdersFno}
          setFilterRejectedOrdersEquity={setFilterRejectedOrdersEquity}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          currentState={state}
          accountName={props.accountName}
          allUser={allUser && allUser}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}



      {currentTab === "order-placement" && <OrderPlacement />}
      {currentTab === "order-tagging" && <OrderTaggingSystem />}
    </div>
  );
}
